export default __webpack_public_path__ + "static/media/bg-banner.19a078fe.svg";